module.exports = __webpack_public_path__ + "static/media/down.eed8c71d.mp3";